import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Menu, Image, Dropdown, Icon, Label, Popup, Input, TransitionablePortal, Segment, Accordion, List, Header, Button, Modal, Form } from 'semantic-ui-react'
import { Images } from '../../assets/assets'
import _ from 'lodash'
import { endpoint, POST } from '../../api/http'
import { onWarning } from '../shared/messages'
import { MenuTypes } from './menutypes'
import PropTypes from "prop-types";
import './style.css'
import { GetUnAssignedRoomCount } from '../../api/services/pms'
import IFrameDialog from '../shared/iframedialog'
import { UpdateUser, GetUserParams } from '../../api/services/organization'
import { GetNotesCount } from '../../api/services/home'
import MenuPopup from './menupopup'
import SearchList from './searchlist'
import qs from 'querystringify'
import { useTextResources } from '../../language';
import { Actions, NoteStatusEnum } from '../shared/constants';
import ApplicationContext from '../../context'
import HotelsDropDown from '../shared/HotelsDropDown'
import UsersDropDown from '../shared/UsersDropDown'
import MediaQuery from 'react-responsive'
import { Menus } from '../../api/services/next'
import { mapPath } from './utils'
import { HomePagePopups } from '../../pages/Home/popups'
import { PopupTypes } from "../../pages/Home/icons"

const MainMenu = ({ HotelId }) => {
    const text = useTextResources()
    const [menuItems, setMenuItems] = useState()
    const [searchItems, setSearchItems] = useState()
    //used in the right menu
    const [setupItemsRightMenu, setSetupItemsRightMenu] = useState()
    const [reportItemsRightMenu, setReportItemsRightMenu] = useState()
    const [hotels, setHotels] = useState([])
    const [hotelId, setHotelId] = useState(HotelId)
    const [user, setUser] = useState({})
    const [notesCount, setNotesCount] = useState(0)
    const [unassigned, setUnassigned] = useState(0)
    const [mainItems, setMainItems] = useState([])
    //Passed to menupopup
    const [settingsItemsPopup, setSettingsItemsPopup] = useState([])
    const [reportItemsPopup, setReportItemsPopup] = useState([])
    const [showSidebar, setShowSidebar] = useState(false)
    const [showModalMenu, setShowModalMenu] = useState(false)
    const isViewHotelsEnable = window.optima.user ? window.optima.user.ActionIDs.includes(Actions.ViewHotels) : true
    const isAdmin = user.UserRoles && user.UserRoles.some(x => x.Role.SystemRoleTypeID === 1)
    const canEditHotels = isViewHotelsEnable && isAdmin
    const {
        setState,
        state: { agentState },
    } = useContext(ApplicationContext)
    const [switchHotelSettings, setSwitchHotelSettings] = useState({ HotelId })
    const [switching, setSwitching] = useState(false)
    const [switchChainOpen, setSwitchChainOpen] = useState(false)
    const [activePopup, setActivePopup] = useState(0)

    const menuActions = {
        ShortReservation: () => setActivePopup(PopupTypes.ShortReservation)
    }


    //run once - set hotelID from url (if specified)
    useEffect(() => {
        const params = qs.parse(window.location.search)
        if (params.hotelId) {
            setHotelId(Number(params.hotelId))
        }
    }, [])

    useEffect(() => {
        (async () => {
            try {
                let [userparams, notes, unassigned] = await Promise.all([
                    GetUserParams(),
                    GetNotesCount({ Status: NoteStatusEnum.Open }),
                    GetUnAssignedRoomCount()
                ])
                setUser(userparams.User)
                setState(prev => ({ ...prev, user: userparams.User }))
                setHotels(userparams.ChainHotels)
                setNotesCount(notes[0].NotesCount)
                setUnassigned(unassigned)
                let menus = await Menus.GetUserMenus()
                //split menu items into different collections by menu type id
                let main = menus.filter(x => x.MenuTypeId === MenuTypes.OptimaMain)
                let setup = menus.filter(x => x.MenuTypeId === MenuTypes.OptimaSetup)
                let silverbyte = menus.filter(x => x.MenuTypeId === MenuTypes.OptimaSilverbyte)
                let reports = menus.filter(x => x.MenuTypeId === MenuTypes.OptimaReports)

                const sortByOrder = (a, b) => {
                    return a.Order - b.Order
                }
                main = main.sort(sortByOrder)
                setup = setup.sort(sortByOrder)
                reports = reports.sort(sortByOrder)
                setMainItems(main)
                setSettingsItemsPopup(setup)
                setReportItemsPopup(reports)

                //Recursive method used to add menu items
                const mapMenu = (items, root = true, newTab = false) => {
                    let currentItems;
                    if (root) {
                        currentItems = items.filter(item => !item.ParentId && items.filter(x => x.ParentId === item.Id).length > 0)
                    } else {
                        currentItems = items
                    }

                    return currentItems.map(item => {
                        if (item.ParentId) {
                            //Add menu item with URL
                            return <Menu.Item key={item.Id} link href={mapPath(item.ViewPath) || "javascript: void(0)"} target={newTab ? "_blank" : ""} onClick={menuActions[item.TranslationResourceKey]}>
                                {item.TranslationResourceKey ? text(item.TranslationResourceKey) : item.Name}
                            </Menu.Item>

                        } else {
                            //If item has child menus -> add the children
                            return <Dropdown simple item text={item.TranslationResourceKey ? text(item.TranslationResourceKey) : item.Name} key={item.Id}>
                                <Dropdown.Menu>
                                    {
                                        mapMenu(items.filter(x => x.ParentId === item.Id), false, newTab)
                                    }
                                </Dropdown.Menu>
                            </Dropdown>
                        }
                    })
                }
                let items = mapMenu(main)

                //add SILVERBYTE ONLY menus (require special permission)
                if (silverbyte && silverbyte.length) {
                    items.push(
                        <Dropdown simple item text="Silverbyte" key="silverbyte">
                            <Dropdown.Menu style={{ width: "max-content" }}>
                                {
                                    mapMenu(silverbyte, true)
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                    )
                }
                setMenuItems(items)

                //add setup items
                let setupItems = mapMenu(setup)
                setSetupItemsRightMenu(setupItems)

                //add report items
                let reportItems = mapMenu(reports, true)
                setReportItemsRightMenu(reportItems)

                //Map items to search component
                const mapSearch = (items, name, root = true) => {
                    let currentItems;
                    if (root) {
                        currentItems = items.filter(item => !item.ParentId && items.filter(x => x.ParentId === item.Id).length > 0)
                    } else {
                        currentItems = items
                    }
                    return currentItems.map(item => {
                        const title = item.TranslationResourceKey ? text(item.TranslationResourceKey) : item.Name;
                        if (item.ParentId) {
                            return {
                                title: title,
                                key: item.Id,
                                path: mapPath(item.ViewPath)
                            }
                        } else {
                            return {
                                name: name ? name + " - " + title : title,
                                key: item.Id,
                                results: mapSearch(items.filter(x => x.ParentId === item.Id), "", false)
                            }
                        }
                    })
                }

                let search = [].concat(mapSearch(main), mapSearch(silverbyte, "Silverbyte"), mapSearch(setup, text("Settings")), mapSearch(reports, text("Reports")))
                search = _.keyBy(search, 'name')
                setSearchItems(search)


            } catch (error) {
                console.error(error)
            }
        })()
    }, [])

    const onChangeHotel = async value => {
        if (value) {
            setHotelId(value)

            let spec = { ...user }
            spec.UserRoles = null
            spec.Menus = null
            spec.DefaultHotelID = value;
            await UpdateUser(spec)
            let params = qs.parse(window.location.search)
            if (params.hotelId) {
                params.hotelId = value;
            } else if (params.hotelid) {
                params.hotelid = value;
            } else {
                params.hotelId = value;
            }
            if (window.optima && window.optima.utils) {
                window.optima.utils.PostMessage({ eventType: 'SwitchHotel' });
            }
            window.location.search = qs.stringify(params, true)

        }
    }
    const currentHotel = hotels.find(hotel => { return hotel.Id === hotelId })
    const hotelName = currentHotel ? currentHotel.Name : ""

    const HotelSwitch = () => {
        const [hotelFilter, setHotelFilter] = useState("")
        return <Dropdown item className="hotels"
            trigger={<div>
                <Icon className="icon-old-building" size="large"></Icon>
                <span style={{ verticalAlign: "middle" }}>Hotel: {hotelName}</span>
            </div>
            }
            onChange={(e, { value }) => onChangeHotel(value)}
            value={hotelId}
            options={
                [].concat(
                    <Input key="filter" icon='filter' iconPosition='left' name='search'
                        onChange={(e, { value }) => setHotelFilter(value)}
                        onClick={e => e.stopPropagation()}
                    />,
                    <Dropdown.Header content={`${user.HotelChainName}`} description={user.HotelChainId} key="chain" />,
                    hotels.filter(hotel => hotelFilter === "" ? true : hotel.Name.toLowerCase().includes(hotelFilter.toLowerCase()))
                        .map(hotel => {
                            return (
                                {
                                    key: hotel.Id,
                                    value: hotel.Id,
                                    text: hotel.Name,
                                    description: canEditHotels ? <a target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} href={`${endpoint}Organization/Hotel/EditHotel?id=${hotel.Id}`}><Icon name="pencil"></Icon></a> : null
                                }
                            )
                        })
                )}
        />
    }

    const OnLogoutClicked = () => {
        if (window.optima && window.optima.utils) {
            window.optima.utils.PostMessage({ eventType: 'Logout' });
        }
    }

    HotelSwitch.propTypes = {
        hotelName: PropTypes.string,
        hotels: PropTypes.array
    }
    const mobileMenus = [33, 39, 44, 34, 35, 180, 42, 43, 173, 175, 46, 48, 194]
    const chainsSpec = useMemo(() => {
        return {
            HotelsForAllChains: true,
            IsActive: true,
            includes: ["HotelChain"],
            MaxResults: 10000,
            UserGroupPermittedForLogin: '777777'
        }
    }, [])

    const usersSpec = useMemo(() => {
        return {
            ChainId: switchHotelSettings.ChainId,
            SpecificSystemRole: 1, //SILVERBYTEADMINISTRATOR
            UserGroupPermittedForLogin: '777777'
        }
    }, [switchHotelSettings])

    const switchToHotel = async () => {
        setSwitching(true)
        try {
            const result = await POST('Organization/Account/InitiateSwitchChainMfa', {
                HotelId: switchHotelSettings.HotelId,
                ChainId: switchHotelSettings.ChainId,
                UserId: switchHotelSettings.UserId
            })

            if (result.twoFactorNotEnabled) {
                onWarning(text('TwoFactorNotEnabledForSwitchChain'))
                setSwitching(false)
                return
            }

            if (result.success && result.mfaToken) {
                setSwitchChainOpen(false)
                const basePath = endpoint.endsWith('/') ? endpoint : endpoint + '/'
                window.location = `${basePath}Organization/Account/TwoFactor?mfaToken=${encodeURIComponent(result.mfaToken)}&phone=${encodeURIComponent(result.phone || '')}`
                return
            }

            onWarning(text('SwitchChainFailed'))
            setSwitching(false)
        } catch (err) {
            onWarning(err?.error || err?.message || text('SwitchChainFailed'))
            setSwitching(false)
        }
    }

    return (
        <React.Fragment>
            {/* responseve mode: full screen */}
            <MediaQuery minWidth={1440}>
                <Menu borderless secondary activeIndex="-1" size="tiny">
                    {/* Optima logo */}
                    <Menu.Item key='logo' link href={`${endpoint}Home/HomePage`}>
                        <Image src={Images.logo} size="mini" />
                    </Menu.Item>

                    {/* switch hotel */}
                    <HotelSwitch />
                    {
                        menuItems
                    }
                    <Menu.Item as="div">
                        <SearchList items={searchItems} />
                    </Menu.Item>
                    {/*  RIGHT MENU*/}
                    <Menu.Menu position="right">
                        <Popup trigger={
                            <Menu.Item icon link href={`${endpoint}/Shell/Messaging?hotelid=${hotelId}`} target="_blank">
                                <Icon name="chat" size="large"></Icon>
                            </Menu.Item>
                        } content={"Messaging"} />
                        <Popup trigger={
                            <Menu.Item icon link href="https://wa.me/972503131497" style={{ color: "#52b563" }} target="_blank">
                                <Icon className="icon-whatsapp" size="large"></Icon>
                            </Menu.Item>
                        } content={"WhatsApp"} />

                        {/* setup menu */}
                        <Dropdown simple item icon={<Icon className="icon-settings-52" size="large"></Icon>}>
                            <Dropdown.Menu style={{ width: "max-content" }}>
                                {setupItemsRightMenu}
                            </Dropdown.Menu>
                        </Dropdown>

                        {/*  REPORTS MENU - todo create icon*/}
                        <Dropdown simple item icon={<Icon className="icon-graphic-progression" size="large"></Icon>}>
                            <Dropdown.Menu style={{ width: "max-content" }}>
                                {reportItemsRightMenu}
                            </Dropdown.Menu>
                        </Dropdown>

                        <Popup trigger={
                            <Menu.Item icon link href="https://www.silverselfie.com/he/optima2020-market/" target="_blank">
                                <Icon className="icon-shopping-cart3" size="large"></Icon>
                            </Menu.Item>
                        } content={text("MarketPlace")} />
                        <Popup trigger={
                            <Menu.Item icon link onClick={() => setShowModalMenu(true)}>
                                <Icon className="icon-menu-1" size="large"></Icon>
                            </Menu.Item>
                        } content={text("OptimaMenu")} />

                        {/* inits the poup menu control*/}
                        <MenuPopup menu={mainItems} settings={settingsItemsPopup} reports={reportItemsPopup} search={searchItems} open={showModalMenu} onClose={() => setShowModalMenu(false)} />


                        <Popup trigger={
                            <Menu.Item icon link href={`${endpoint}SharedServices/Notes/Index?hotelid=${hotelId}`} target="_blank">
                                <Icon className="icon-businessman-17" size="large">
                                    <Label color='blue' floating circular size="medium">
                                        {notesCount}
                                    </Label>
                                </Icon>
                            </Menu.Item>
                        } content={text("Notes")} />
                        <Popup position="bottom right" trigger={
                            <Menu.Item icon link href={`${endpoint}PMS/Reservations/Search?IsUnassignedRoomsOnly=true&Statuses=1`} target="_blank">
                                <Icon className="icon-calendar" size="large">
                                    <Label color={unassigned == 0 ? 'green' : 'orange'} floating circular size="medium">
                                        {unassigned}
                                    </Label>
                                </Icon>
                            </Menu.Item>
                        } content={text("RoomAssignment")} />
                        <Dropdown simple item trigger={
                            <div>
                                <Image src={Images.login_avatar} avatar size="mini" />
                                <span style={{ verticalAlign: "middle" }}>{user.UserName}</span>
                            </div>
                        }>
                            <Dropdown.Menu>
                                <Menu.Item link href={`${endpoint}Organization/User/Edit?isUserProfile=true&userID=${user.Id}`}>{text("Profile")}</Menu.Item>
                                <IFrameDialog trigger={
                                    <Menu.Item>{text("Chat")}</Menu.Item>
                                } size="mini" title="Chat" src="https://tawk.to/chat/5db156ae78ab74187a5b4986/default" />
                                <IFrameDialog trigger={
                                    <Menu.Item>{text("Updates")}</Menu.Item>
                                } size="fullscreen" title="Updates" src="https://www.silverselfie.com/he/optima-2020-new-update/" />
                                <Menu.Item link href={`${endpoint}Download/Agent/Silverbyte.Optima.Agent.application`}>{text(agentState)}</Menu.Item>
                                <Dropdown.Divider />
                                {isAdmin && user.UserSettings?.[0]?.UserGroupPermittedForLogin === '666666' &&
                                    <Menu.Item onClick={() => setSwitchChainOpen(true)}>{text("SwitchChain")}</Menu.Item>
                                }
                                <Menu.Item link href={`${endpoint}Organization/Account/LogOut`} onClick={OnLogoutClicked}>{text("LogOut")}</Menu.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Menu>
                </Menu>
                {isAdmin && user.UserSettings?.[0]?.UserGroupPermittedForLogin === '666666' &&
                    <Modal size="small" open={switchChainOpen} onClose={() => setSwitchChainOpen(false)}>
                        <Modal.Header>{text("SwitchChain")}</Modal.Header>
                        <Modal.Content>
                            <Form>
                                <Form.Group widths="equal">
                                    <Form.Field search label={text("SelectHotel")} control={HotelsDropDown}
                                        value={switchHotelSettings.HotelId} onChangeItem={item => {
                                            setSwitchHotelSettings({
                                                ...switchHotelSettings,
                                                HotelId: item.Id,
                                                ChainId: item.HotelChainId,
                                                UserId: null
                                            })
                                        }} spec={chainsSpec}
                                        descriptionField={hotel => {
                                            return hotel.HotelChain.Name
                                        }} />
                                    <Form.Field search label={text("SelectUser")} control={UsersDropDown}
                                        value={switchHotelSettings.UserId} onChange={value => {
                                            setSwitchHotelSettings({
                                                ...switchHotelSettings,
                                                UserId: value
                                            })
                                        }} spec={usersSpec} selectFirst={options => {
                                            return options.find(o => o.text.toLowerCase().startsWith("support"))
                                        }}
                                        descriptionField={user => {
                                            return user.Email
                                        }} />
                                </Form.Group>
                            </Form>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button disabled={!(switchHotelSettings.ChainId && switchHotelSettings.UserId) || switching} loading={switching} positive onClick={switchToHotel}>{text("Switch")}</Button>
                        </Modal.Actions>
                    </Modal>}
            </MediaQuery>

            {/* MOBILE MENU */}
            <MediaQuery maxWidth={1440}>
                <Menu borderless activeIndex="-1" size="tiny" className="mobile-menu">
                    <Menu.Item key='logo' link href={`${endpoint}Home/HomePage`}>
                        <Image src={Images.logo} size="mini" />
                    </Menu.Item>
                    <HotelSwitch />
                    <Menu.Menu position="right">
                        <Menu.Item icon={<Icon name="bars" size="large" />} onClick={() => setShowSidebar(!showSidebar)} />
                    </Menu.Menu>
                </Menu>
                <TransitionablePortal open={showSidebar} transition={{ animation: 'fade right' }}>
                    <Segment className="MainMobileMenu"
                        style={{
                            left: 0,
                            top: 0,
                            bottom: 0,
                            right: 0,
                            position: 'absolute',
                            zIndex: 1000,
                            margin: 0,
                            opacity: 1
                        }}
                    >
                        <div style={{ width: '100%' }}>
                            <Icon name="close" style={{ float: 'right' }} onClick={() => setShowSidebar(false)} />
                        </div>
                        <Header icon as="h2" style={{ width: '100%' }}>
                            <Icon className="icon-user-3" />
                            <Header.Subheader>
                                {hotelName}
                            </Header.Subheader>
                            <Header.Subheader>
                                {user.FirstName}
                            </Header.Subheader>
                        </Header>
                        <Header style={{ width: '100%' }} textAlign="center">
                            <Button as='a' href={`${endpoint}/Organization/Account/LogOut`}>Log Out</Button>
                        </Header>

                        <Accordion styled panels={
                            mainItems.filter(item => mobileMenus.includes(item.Id) && !item.ParentId).map(item => {
                                return {
                                    key: item.Id,
                                    title: item.Name,
                                    content: (
                                        <List as={Accordion.Content} link>
                                            {
                                                mainItems.filter(sitem => mobileMenus.includes(sitem.Id) && sitem.ParentId === item.Id).map(sitem => {
                                                    return <List.Item key={sitem.Id} href={mapPath(sitem.ViewPath)}>{sitem.Name}</List.Item>
                                                })
                                            }
                                        </List>
                                    )
                                }
                            })
                        }>
                        </Accordion>
                    </Segment>
                </TransitionablePortal>
            </MediaQuery>
            {Boolean(activePopup) && <HomePagePopups active={activePopup} HotelId={hotelId} onClose={() => setActivePopup(0)} />}
        </React.Fragment>
    )
}
MainMenu.propTypes = {
    HotelId: PropTypes.number
}
export default MainMenu
